import React from 'react';
import Menu from '../components/menu/menu.jsx';
import Content from '../components/content/content.jsx';

function NotFound() {
  return (
    <div>
      <Menu />
      <Content>
        <h1>404 — Nie znaleziono strony</h1>
        <p>Przepraszamy, strona nie istnieje.</p>
        <p>Możesz wrócić na <a href="/">stronę główną</a>.</p>
      </Content>
    </div>
  );
}

export default NotFound;
